import { render, staticRenderFns } from "./clock.vue?vue&type=template&id=1415fdb6&scoped=true"
import script from "./clock.vue?vue&type=script&lang=js"
export * from "./clock.vue?vue&type=script&lang=js"
import style0 from "./clock.vue?vue&type=style&index=0&id=1415fdb6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1415fdb6",
  null
  
)

export default component.exports